<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人办事</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">国内婚姻登记</h2>
            <ul>
              <li  style="padding-right: 30px;" class="none">
                <el-tooltip content="结婚登记预约" placement="bottom"></el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IA',title:'结婚登记预约', swFlag: 0})"  class="civil_icon3"><img src="../../static/images/jhdjyy.png"><span>结婚登记预约</span></a>
              </li>
              <li  style="padding-right: 30px;" class="none">
                <!--                  <el-tooltip content="离婚申请预约" placement="bottom">-->
                <!--                    &lt;!&ndash;                   <a href="javascript:void(0)"    class="civil_icon0"><img src="../../static/images/icon16_lock.png"><span>困境儿童</span></a>&ndash;&gt;&ndash;&gt;-->
                <!--                  </el-tooltip>-->
                <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IBSQ',title:'离婚申请预约'})"  class="civil_icon1"><img src="../../static/images/lhsqyy.png"><span>离婚申请预约</span></a>
              </li>
              <li  style="padding-right: 30px" class="none">
                <el-tooltip content="离婚登记预约" placement="bottom"></el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IB',title:'离婚登记预约', swFlag: 0})"  class="civil_icon5"><img src="../../static/images/lhdjyy.png"><span>离婚登记预约<br /></span></a>
              </li>
              <li style="padding-right: 30px" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICA',title:'补领结婚证预约', swFlag: 0})"  class="civil_icon7"><img src="../../static/images/bljhzyy.png"><span>补领结婚证预约</span></a></li>
              <li style="padding-right: 30px;padding-top: 20px" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICB',title:'补领离婚证预约', swFlag: 0})"  class="civil_icon2"><img src="../../static/images/bllhzyy.png"><span>补领离婚证预约</span></a></li>
            </ul>
          </div>
        </div>

        <div class="clear"></div>
        <div class="wraper">
          <div class="civil_part1">
            <h2 class="tit">涉外婚姻登记</h2>
            <ul>
              <li  style="padding-right: 30px;" class="none">
                <el-tooltip content="涉外、涉港澳台居民及华侨结婚登记预约" placement="bottom"></el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IA',title:'涉外、涉港澳台居民及华侨结婚登记预约', swFlag: 1})"  class="civil_icon3"><img src="../../static/images/jhdjyy.png"><span>涉外、涉港澳台居民及华侨结婚登记预约</span></a>
              </li>
              <li  style="padding-right: 30px;" class="none">
                <el-tooltip content="涉外、涉港澳台居民及华侨离婚申请预约" placement="bottom">
                  <!--                   <a href="javascript:void(0)"    class="civil_icon0"><img src="../../static/images/icon16_lock.png"><span>困境儿童</span></a>&ndash;&gt;-->
                </el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IBSQ',title:'涉外、涉港澳台居民及华侨离婚申请预约', swFlag: 1})"  class="civil_icon1"><img src="../../static/images/lhsqyy.png"><span>涉外、涉港澳台居民及华侨离婚申请预约</span></a>
              </li>
              <li  style="padding-right: 30px;" class="none">
                <el-tooltip content="涉外、涉港澳台居民及华侨离婚登记预约" placement="bottom"></el-tooltip>
                <a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'IB',title:'涉外、涉港澳台居民及华侨离婚登记预约', swFlag: 1})"  class="civil_icon5"><img src="../../static/images/lhdjyy.png"><span>涉外、涉港澳台居民及华侨离婚登记预约<br /></span></a>
              </li>
              <li style="padding-right: 30px;" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICA',title:'涉外、涉港澳台居民及华侨补领结婚证预约', swFlag: 1})"  class="civil_icon7"><img src="../../static/images/bljhzyy.png"><span>涉外、涉港澳台居民及华侨补领结婚证预约</span></a></li>
              <li style="padding-right: 30px;padding-top: 20px;" class="none"><a href="javascript:void(0)"   @click="urlTo('marriageAppointment',{opType:'ICB',title:'涉外、涉港澳台居民及华侨补领离婚证预约', swFlag: 1})"  class="civil_icon2"><img src="../../static/images/bllhzyy.png"><span>涉外、涉港澳台居民及华侨补领离婚证预约</span></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="line-height: 35px;">
      <el-dialog @close="close(1)" :visible.sync="clauseShow" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">{{cTitle}}</div>
        <div v-if="cContent!==''" style="font-size: 14px;margin-left: 40px;margin-right: 35px;"><p v-html="this.cContent">{{cContent}}</p></div>
        <div v-else>
          <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
            <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
            <div>暂无数据</div>
          </div>
        </div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button  type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
export default {
  name: "apply-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      pageNum:1,
      pageSize:6,
      tsData:[],
      jyData:[],
      zxData:[],
      clauseShow:false,
      cContent:'',
      cTitle:'',
      url:'',
      title:'',
      service_code:'',
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  created(){
  },
  methods: {
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
    showClause(url,service_code,title){
      this.$message({
        message: '暂未开放',
        type: 'warning'
      });
      return;
      this.url=url;
      this.service_code=service_code;
      this.title=title;
      this.clauseClose();
      // var t=this;
      //   this.$https.get("api/pu/clause/getClauseContentByType.do",{cType:service_code},response=>{
      //     if (response.status === 200 && response.data.code===200) {
      //       t.cTitle=response.data.data.cTitle;
      //       t.cContent=response.data.data.cContent;
      //     }
      //     t.clauseShow=true;
      //   })
    },
    clauseClose(){
      this.clauseShow=false;
      this.urlTo(this.url,{service_code:this.service_code,title:this.title})
    },
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ApplyIndex_marriage.vue